<script>
export default {
  props: {
    isPass: {
      type: Boolean,
      default: false
    }
  }
}
</script>
<template>
  <div
    class="steps-link"
    :class="{
      'steps-link__pass': isPass
    }"
  >
    <div class="big-point" />
    <div class="point" />
    <div class="point" />
    <div class="point" />
    <div class="point" />
    <div class="point" />
    <div class="big-point" />
  </div>
</template>
<style scoped>
.steps-link {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  height: fit-content;
  margin-top: 12px;
  margin-left: 48px;
  margin-right: 48px;
}
.point {
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background-color: #d4dde8;
  margin-left: 13px;
}
.big-point:last-child {
  margin-left: 13px;
}
.big-point {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: #d4dde8;
}
.steps-link__pass > div {
  background-color: #4c6ef580;
}
</style>
